document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('click', (event) => {
  const openButton = event.target.closest('[data-gallery-open]');
  if (openButton) {
    const dialog = document.getElementById(openButton.dataset.galleryOpen);
    if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    return;
  }

  const closeButton = event.target.closest('[data-gallery-close]');
  if (closeButton) {
    const dialog = closeButton.closest('dialog');
    if (dialog) dialog.close();
    return;
  }

  if (event.target instanceof HTMLDialogElement) {
    const bounds = event.target.getBoundingClientRect();
    const inside = event.clientX >= bounds.left && event.clientX <= bounds.right && event.clientY >= bounds.top && event.clientY <= bounds.bottom;
    if (!inside) event.target.close();
  }
});

document.querySelectorAll('.mobile-menu a').forEach((link) => {
  link.addEventListener('click', () => {
    const menu = link.closest('details');
    if (menu) menu.removeAttribute('open');
  });
});

document.querySelectorAll('[data-variant-select]').forEach((select) => {
  select.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    const productInfo = select.closest('.product-info');
    if (!productInfo) return;

    const price = productInfo.querySelector('[data-product-price]');
    const button = productInfo.querySelector('[data-add-to-cart]');
    const available = option.dataset.available === 'true';

    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (button) {
      button.disabled = !available;
      button.firstChild.textContent = available ? 'Add to cart ' : 'Sold out ';
    }
  });
});
